// ----------------------------------------------------------------------

export function remToPx(value) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg),
    },
  };
}

export const primaryFont = {
  style: { fontFamily: '"Inter", Helvetica, Arial, sans-serif' },
  className: 'font-primary',
};

export const secondaryFont = {
  style: { fontFamily: '"Roboto", Helvetica, Arial, sans-serif' },
  className: 'font-secondary',
};

export const signatureFont = {
  style: { fontFamily: '"DancingScript", Helvetica, Arial, sans-serif' },
  className: 'font-signature',
};

// ----------------------------------------------------------------------

// LEARN MORE
// https://nextjs.org/docs/basic-features/font-optimization#google-fonts

export const typography = {
  fontFamily: primaryFont.style.fontFamily,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontWeight: 700,
    lineHeight: 80 / 64,
    fontSize: pxToRem(40),
    ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 }),
  },
  h2: {
    fontWeight: 700,
    lineHeight: 64 / 48,
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
  },
  h3: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(24),
    ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 }),
  },
  h4: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
  },
  h5: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
  },
  h6: {
    fontWeight: 700,
    lineHeight: 28 / 18,
    fontSize: pxToRem(17),
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  body1: {
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  body2: {
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(12),
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 700,
    lineHeight: 24 / 14,
    fontSize: pxToRem(14),
    textTransform: 'unset',
  },

  header1: {
    fontSize: pxToRem(28),
    fontWeight: 700,
    lineHeight: pxToRem(42),
    letterSpacing: '-0.041em',
  },

  header3: {
    fontSize: pxToRem(20),
    fontWeight: 700,
    lineHeight: pxToRem(30),
    letterSpacing: '-0.041em',
  },

  header4: {
    fontSize: pxToRem(18),
    fontWeight: 700,
    lineHeight: pxToRem(27),
    letterSpacing: '-0.041em',
  },

  text1: {
    fontSize: pxToRem(16),
    fontWeight: 500,
    lineHeight: pxToRem(24),
    letterSpacing: '-0.041em',
  },

  text2: {
    fontSize: pxToRem(14),
    fontWeight: 500,
    lineHeight: pxToRem(21),
    letterSpacing: '-0.041em',
  },

  text3: {
    fontSize: pxToRem(12),
    fontWeight: 500,
    lineHeight: pxToRem(18),
    letterSpacing: '-0.041em',
  },

  chip1: {
    fontFamily: secondaryFont.style.fontFamily,
    fontSize: pxToRem(11),
    fontWeight: 500,
    lineHeight: pxToRem(16),
    letterSpacing: '0.5px',
  },
};
